<template>
  <v-progress-circular
    indeterminate
    :color="color"
    :size="size"
    v-show="isloading"
    :width="width"
    :class="{ 'absolute-een-spinner': absolute, 'een-spinner': true }"
  ></v-progress-circular>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    isloading: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 70
    },
    width: {
      type: Number,
      default: 7
    },
    color: {
      type: String,
      default: "primary"
    },
    absolute: {
      type: Boolean,
      default: true
    }
  },
};
</script>

<style lang="scss">
  .absolute-een-spinner {
    position: fixed;
    top: 45%;
    left: 47%;
  }
</style>


